/**
 * ActivationLibraryCtrl controller
 * Show subscribers library on activation page
 */

// controller mixins
ActivationLibraryCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * ActivationLibraryCtrl controller
 *
 * @class ActivationLibraryCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ActivationLibraryCtrl
 */
/* @ngInject */
export default function ActivationLibraryCtrl ($scope, $uibModal, $http, LibraryContent, subscr, scope) {
  var vm = this

  /**
   * List of tabs
   *
   * @type {string[]}
   */
  vm.tabs = ['channels', 'channels-bundles', 'live-events', 'vods', 'vod-bundles', 'tv-shows', 'seasons', 'episodes', 'tv-show-bundles', 'multi-bundles']

  /**
   * An object containing labels for the Content Library tab.
   */
  vm.CONTENT_LIBRARY_TAB_LABELS = {
    channels: 'Channels',
    'channels-bundles': 'Channel Bundles',
    'live-events': 'Live Events',
    vods: 'VODs',
    'vod-bundles': 'VOD Bundles',
    'tv-shows': 'TV Show',
    seasons: 'Seasons',
    episodes: 'Episodes',
    'tv-show-bundles': 'TV Show Bundles',
    'multi-bundles': 'Multi Bundles'
  }

  /**
   * Active tab default value
   *
   * @type {number}
   */
  // vm.activeTab = 0

  /**
   * Shared scope
   *
   * @memberof mwApp/subscribers.controller:ActivationDevicesCtrl
   * @type {Object}
   */
  vm.scope = scope

  $scope.$watch('vm.activeTab', () => {
    vm.activeTabName = vm.tabs[vm.activeTab] || vm.tabs[0]
    $scope.$broadcast('dispatch: library', vm.activeTabName)
  })
}
